<template>
  <v-container fluid class="pa-0 mx-0">
    <shipment-list :shipments="shipments"></shipment-list>
  </v-container>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import ShipmentList from "@/components/ShipmentList.vue";
export default {
  name: "ShipmentList",
  mixins: [generalMixin],
  components: { "shipment-list": ShipmentList },
  mounted: function () {},
  data() {
    return {};
  },
  computed: {
    shipments: {
      get() {
        return this.$store.getters["shipments"];
      },
      set(val) {
        this.$store.commit("setShipments", val);
      },
    },
  },
  methods: {},
};
</script>
<style>
.payment-paid {
  background-color: lightgreen;
}
</style>
